<template>
    <el-drawer :title="title" :visible.sync="isShow" direction="rtl" ref="drawer" :size="'75%'" :show-close="true"
        :destroy-on-close="true" @close="close" append-to-body>
        <div class="main">
            <div class="left">
                <div class="title">备选图片(单击选择)</div>
                <div class="picture-list">
                    <div class="picture-card" @click="addImage(img)" v-for="(img, i) in images" :key="i">
                        <img :src="baseUrl + img" />
                        <i class="el-icon-check"></i>
                    </div>
                </div>
            </div>
            <div class="right">
                <div class="title">已选图片(单击移除)</div>
                <div class="picture-list">
                    <div class="picture-card" @click="removeImage(img)" v-for="(img, i) in pickImages" :key="i">
                        <img :src="baseUrl + img" />
                        <i class="el-icon-close"></i>
                    </div>
                </div>
            </div>
        </div>
    </el-drawer>
</template>

<script>
export default {
    props: {
        value: [String, Object, Array]
    },
    data() {
        return {
            title: '',
            isShow: false,
            baseUrl: process.env.VUE_APP_BASE_API,
            images: [],
            pickImages: []
        }
    },
    methods: {
        addImage(img) {
            this.pickImages.push(img);
            let index = this.images.indexOf(img);
            this.images.splice(index, 1);
        },
        removeImage(img) {
            this.images.push(img);
            let index = this.pickImages.indexOf(img);
            this.pickImages.splice(index, 1);
        },
        open(images) {
            this.isShow = true;
            this.images = [...images]; //解构赋值，不然会影响父组件中的images
            //根据 value 生成 pickImages
            if (this.$utils.isValid(this.value)) this.pickImages = this.value.split(',')
            else this.pickImages = []
            //排除已选图片
            this.pickImages.forEach(el => {
                let index = this.images.indexOf(el);
                if (index > -1) this.images.splice(index, 1);
            });

        },
        close() {
            this.isShow = false;
            let json = this.pickImages.join(",");
            this.$emit("input", json);
        }
    }
}
</script>

<style scoped>
.main {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    margin-left: 10px;
}

.title {
    margin: 10px;
}

.left {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin: 10px;
}

.right {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin: 10px;
}

.picture-list {
    width: 100%;
    height: 85vh;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    border: 1px dashed #1890ff;
    border-radius: 20px;
}

.picture-card {
    width: 146px;
    height: 146px;
    display: flex;
    margin: 10px;

    position: relative;
    cursor: pointer;
}

.picture-card img {
    width: 100%;
    height: 100%;
    border-radius: 6px;

}

/* icon-plus初始隐藏 */
.picture-card i {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    color: white;
    font-size: 30px;

    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.4);

    border-radius: 6px;
    opacity: 0;
    transition: opacity 0.3s;
    pointer-events: none;
}

/* 悬停时显示遮罩 */
.picture-card:hover i {
    opacity: 1;
    pointer-events: auto;
}
</style>